import type { ImageSizing } from 'voyager';
import { buildImgixImageUrl } from './buildImgixImageUrl';
import type { ImgixImageParams } from './buildImgixImageUrl';

const toImgixParams = (sizing?: ImageSizing): ImgixImageParams => {
  if (!sizing?.width) return { w: 1200, fit: 'max' };
  if (sizing.aspectRatio) {
    return { w: sizing.width, ar: sizing.aspectRatio, fit: 'crop', crop: 'entropy' };
  }
  return { w: sizing.width, fit: 'max' };
};

export const imgixImageTransform = (src: string, sizing?: ImageSizing): string =>
  buildImgixImageUrl(src, toImgixParams(sizing)) ?? src;
